import React from 'react';
import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Wrapper from '../../components/templates/SchoolWrapper';
import Title from '../../components/Service/SchoolGetStarted/Title';
import StepOne from '../../components/Service/SchoolGetStarted/StepTwo';
import StepTwo from '../../components/Service/SchoolGetStarted/StepThree';
import StepThree from '../../components/Service/SchoolGetStarted/StepFour';
import StepFour from '../../components/Service/SchoolGetStarted/StepFive';

const SchoolGetStartedMain = () => {
  const { t } = useTranslation('common');
  return (
    <Wrapper>
      <>
        <Head>
          <title>{t('title.school.gettingStarted')}</title>
          <meta
            name="description"
            content={t('service.school.gettingStarted.intro')}
          />
        </Head>
        <div className="school-main-content">
          <Title />
          <StepOne />
          <StepTwo />
          <StepThree />
          <StepFour />
        </div>
      </>
    </Wrapper>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});

export default SchoolGetStartedMain;
